import Text from '@/components/Text';
import { AppointmentConfirmationType } from '@/utils/appointments';

export const DefaultAppointmentConfirmationToast = ({
  confirmationType,
}: {
  confirmationType: AppointmentConfirmationType;
}) => {
  const scheduledOrRescheduledCopy =
    confirmationType === AppointmentConfirmationType.Reschedule
      ? 'rescheduled'
      : 'scheduled';
  return (
    <Text.P.Inline>
      <Text.P.Inline.Bold>Success! </Text.P.Inline.Bold>Your appointment has
      been {scheduledOrRescheduledCopy}, and your provider has been notified.
    </Text.P.Inline>
  );
};
